/**
 * Notifications/View Controller
 *
 * 
 */

// the constructor for this object
function NotificationsViewController() { }

// the object
NotificationsViewController.prototype = {
    constructor: NotificationsViewController,
    
    // the cmc contact email id
    notificationId: false,
    
    // initialize the controller
    init: function() 
    {
        // the user must be logged in to access this page
        PortalMain.authRedirect();
        
        // register the route variables used by this controller
        this._registerRouteVariables();
        
        PortalHelper.debugMessage('Notifications View Controller Initialized');
    },
    
    // run the controller
    run: function()
    {
        // Populate the trouble tickets section
        this._getNotification();
        
        // register the events used by this controller
        this._registerEvents();
        
        PortalHelper.debugMessage('Notifications View Controller Ran');
    },
    
    // get the route variables and include them in the controller
    _registerRouteVariables: function() 
    {
        var segments = PortalMain.getRouteSegments();
        
        // set the product cd
        if (segments.length == 1) {
            this.notificationId = segments[0];
        } else {
            // the uri is missing important pieces
            PortalHelper.sendToDashboard();
        }
    },
    
    // register the javascript events
    _registerEvents:  function() 
    {   
    
    },
    
    // get the notifications
    _getNotification: function()
    {
        var notificationRequest = new PortalRequest;
        notificationRequest.makeRequest(
            '/notifications/get-cmc-notification',
            {
                notificationId: this.notificationId
            },
            function(data) {
                // display the notification details
                PortalMain.NotificationsViewController._populateNotification(data);
                
                // populate the inquire button
                PortalMain.NotificationsViewController._populateInquire(data);
            }
        );
    },
    
    // display the notification
    _populateNotification: function(notification)
    {
        var batch = notification.cmc_contact_batch;
        
        // apply the subject
        $('.subject').html(batch.subject);

        $('.posted').attr('data-tooltip',notification.created_readable);
        $('.posted .date-diff').html(notification.created_diff_humans);

        // apply the schedule event
        $('.scheduled-event .value').html(batch.scheduled_event);
        
        // apply the service affecting
        $('.service-affecting .value').html(batch.service_affecting);
        
        // apply the area
        $('.area .value').html(batch.area);
        
        // apply the ticket nubmer
        $('.ticket-number .value').html(batch.ticket_number);
        
        // apply the date
        $('.date .value').html(batch.date);
        
        // apply the duration of interruption
        $('.duration-of-interruption .value').html(batch.duration_of_interruption);
        
        // apply the start time
        $('.start-time .value').html(batch.window_start_time);
        
        // apply the end time
        $('.end-time .value').html(batch.window_end_time);
        
        // apply the description
        var description = PortalHelper.breaksToBr(batch.description_of_work);
        $('#description').html(description);
        
        var circuitsAffected = '';
        if (batch.circuits_affected) {
            circuitsAffected = batch.circuits_affected;
        } else {
            circuitsAffected = notification.circuit_ids;
        }
        circuitsAffected = PortalHelper.breaksToBr(circuitsAffected);
        $('#circuits-affected').html(circuitsAffected);
        
        // turn off the loading, and the start-hidden
        PortalHelper.loadingOverlay('#notification', false);
    },
    
    
    // fill in details for the inquire button
    _populateInquire: function(notification)
    {
        var inquireLink = PortalConfig.portalUrl;
        inquireLink += '/inquire/notification/' + notification.cmc_contact_batch.ticket_number;
        
        $('#inquire-button').attr('href', inquireLink);
        
        PortalHelper.enableButton('#inquire-button');
    },
}